import { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'

export function useGoogleAnalytics() {
  const location = useLocation()
  useEffect(() => {
    const page = location.pathname + location.search
    ReactGA.send({ hitType: 'pageview', page })
  }, [location])
}

export function initializeGoogleAnalytics() {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID)
}
